<template>
  <PageContainer title="Política de privacidade">
    <Box space="medium">
      <h1>Política de Privacidade - Aplicativo de Monitoramento do NOVOCFC</h1>

      <p><strong>Última atualização:</strong> 04/02/2025</p>

      <p><strong>A presente</strong> Política de Privacidade descreve como coletamos, utilizamos, armazenamos e
        protegemos os dados
        pessoais dos usuários e visitantes do nosso aplicativo de monitoramento do NOVOCFC. Ao utilizar nosso
        aplicativo, você concorda com as práticas descritas nesta política.</p>
      <p><strong>O presente documento foi elaborado em conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei
          13.709/18), o Marco Civil da Internet (Lei 12.965/14) e o Regulamento da UE n. 2016/6790. Ainda, o documento
          poderá ser atualizado em decorrência de eventual atualização normativa, razão pela qual se convida o usuário a
          consultar periodicamente esta seção.</strong></p>

      <h2>1. Como os dados pessoais do usuário e visitante são recolhidos pela plataforma?</h2>
      <p>Os dados pessoais são recolhidos das seguintes formas:</p>
      <h3>1.1. Cadastro na plataforma:</h3>
      <p>A conta do usuário é criada em nossa plataforma com base nos dados fornecidos pelo DETRAN, órgão responsável
        pelo cadastro inicial. Esses dados incluem informações de identificação básicas, como:</p>
      <ul>
        <li>Nome completo;</li>
        <li>CPF;</li>
        <li>Renach.</li>
      </ul>
      <p>O cadastro não é realizado diretamente no aplicativo, mas sim na plataforma da empresa, que é licenciada para
        operar o monitoramento de veículos (motos e carros) conforme a legislação do DETRAN.</p>
      <h3>1.2. Uso do aplicativo:</h3>
      <p>Durante o uso do aplicativo, coletamos informações sobre a interação do usuário, incluindo:</p>
      <ul>
        <li>Localização via GPS para monitoramento das aulas práticas de moto e carro;</li>
        <li>Fotos e provas de vida (biometria facial) para validação da presença do aluno durante as aulas;</li>
        <li>Dados de acesso, como endereço IP, tipo de navegador e horários de utilização.</li>
      </ul>
      <h3>1.3. Dados fornecidos por terceiros:</h3>
      <p>Recebemos dados pessoais do DETRAN, órgão responsável pelo cadastro inicial dos alunos, instrutores e veículos.
        Esses dados são utilizados exclusivamente para fins de monitoramento e cumprimento das obrigações legais.</p>

      <h2>2. Quais dados pessoais do usuário são recolhidos?</h2>
      <p>Os dados pessoais recolhidos incluem, mas não se limitam a:</p>
      <ul>
        <li>Nome completo;</li>
        <li>CPF;</li>
        <li>Renach;</li>
        <li>Localização via GPS durante as aulas práticas;</li>
        <li>Fotos e provas de vida (biometria facial);</li>
        <li>Dados de acesso ao aplicativo (endereço IP, tipo de navegador, horários de utilização).</li>
      </ul>

      <h2>3. Para que finalidades utilizamos os dados pessoais do usuário?</h2>
      <p>Os dados pessoais são utilizados para as seguintes finalidades:</p>
      <ul>
        <li>Monitoramento e registro das aulas práticas de moto e carro, conforme exigido pela legislação do DETRAN;
        </li>
        <li>Validação da presença do aluno durante as aulas por meio de fotos e provas de vida;</li>
        <li>Garantir a segurança e o cumprimento das normas de trânsito durante as aulas;</li>
        <li>Melhorar a experiência do usuário no aplicativo;</li>
        <li>Cumprir obrigações legais e regulatórias.</li>
      </ul>

      <h2>4. Por quanto tempo os dados pessoais ficam armazenados?</h2>
      <p>Os dados pessoais são armazenados em nossos servidores por um período de 5 anos, conforme exigido pela
        legislação aplicável. Após esse período, os dados são excluídos de forma segura.</p>

      <h2>5. Os dados pessoais armazenados serão transferidos a terceiros?</h2>
      <p>Os dados pessoais são compartilhados exclusivamente com o DETRAN, órgão responsável pelo monitoramento e
        regulamentação das aulas práticas de direção. Não compartilhamos os dados com outros terceiros, exceto quando
        exigido por lei.</p>

      <h2>6. Uso de Localização via GPS</h2>
      <p>O aplicativo utiliza a localização via GPS para monitorar e registrar as aulas práticas de moto e carro. Essa
        funcionalidade é essencial para garantir o cumprimento das normas do DETRAN e a segurança do aluno durante as
        aulas. A localização é coletada apenas durante o uso do aplicativo e não é compartilhada com terceiros, exceto
        com o DETRAN.</p>

      <h2>7. Segurança dos Dados</h2>
      <p>Implementamos medidas técnicas e organizacionais para proteger os dados pessoais dos usuários contra acesso não
        autorizado, alteração, divulgação ou destruição. Todas as informações são armazenadas em servidores seguros e
        criptografados.</p>

      <h2>8. Direitos do Usuário</h2>
      <p>Os usuários têm o direito de:</p>
      <ul>
        <li><strong>Acessar seus dados pessoais:</strong> O usuário pode solicitar acesso aos dados pessoais que
          coletamos e armazenamos.</li>
        <li><strong>Solicitar a correção de dados incorretos ou incompletos:</strong> Caso identifique dados incorretos
          ou desatualizados, o usuário pode solicitar a correção.</li>
        <li><strong>Solicitar a exclusão de seus dados pessoais:</strong> O usuário pode solicitar a exclusão de seus
          dados pessoais, exceto quando a retenção for necessária para cumprir obrigações legais ou regulatórias.</li>
      </ul>
      <p><strong>Observação importante:</strong></p>
      <p>Qualquer solicitação de <strong>alteração</strong>, <strong>correção</strong> ou <strong>exclusão</strong> de
        dados pessoais deve ser feita <strong>diretamente à
          autoescola</strong> responsável pelo cadastro do usuário. A autoescola, por sua vez, entrará em contato com o
        DETRAN para
        realizar as alterações necessárias, conforme os procedimentos estabelecidos pelo órgão.</p>
      <p>Nossa plataforma atua como intermediária no monitoramento das aulas práticas, e os dados são fornecidos e
        gerenciados pelo DETRAN. Portanto, não temos autonomia para alterar ou excluir dados sem a devida solicitação da
        autoescola e autorização do DETRAN.</p>
      <p>Para exercer esses direitos, o usuário deve entrar em contato com a autoescola responsável pelo seu cadastro.
        Em caso de dúvidas ou orientações adicionais, o usuário pode entrar em contato conosco através dos canais de
        suporte disponíveis.</p>

      <h2>9. Alterações na Política de Privacidade</h2>
      <p>Esta Política de Privacidade pode ser atualizada periodicamente para refletir mudanças em nossas práticas ou na
        legislação aplicável. Recomendamos que os usuários revisem esta política regularmente.</p>

      <h2>10. Consentimento</h2>
      <p><strong>Ao utilizar os serviços e fornecer as informações pessoais na plataforma, o usuário está consentindo
          com a
          presente Política de Privacidade.</strong></p>
      <p><strong>
          O usuário, ao cadastrar-se, manifesta conhecer e pode exercitar seus direitos de cancelar seu cadastro,
          acessar
          e atualizar seus dados pessoais e garante a veracidade das informações por ele disponibilizadas, mediante
          instruções do Item 8.
        </strong></p>
      <p><strong>
          O usuário tem direito de retirar o seu consentimento a qualquer tempo, para tanto deve entrar em contato sua
          autoescola.
        </strong></p>

      <h2>11. Contato</h2>
      <p>Em caso de dúvidas ou solicitações relacionadas a esta Política de Privacidade, entre em contato conosco
        através do e-mail: <a href="mailto:novocfcfbinfo@gmail.com">novocfcfbinfo@gmail.com</a> ou pelo telefone: +55
        (85)9 8164-4963.</p>

      <h2>12. Jurisdição Para Resolução De Conflitos</h2>
      <p><strong>Para a solução de controvérsias decorrentes do presente instrumento será aplicado integralmente o
          Direito
          brasileiro.</strong></p>
      <p><strong>Os eventuais litígios deverão ser apresentados no foro da comarca em que se encontra a sede da
          empresa.</strong></p>

      <p class="focus"><strong>Agradecemos por utilizar nosso aplicativo!</strong></p>
    </Box>
  </PageContainer>
</template>

<script>
import PageContainer from 'core/PageContainer'
import Box from 'core/Box'

export default {
  name: 'PrivacyPolicy',
  components: {
    PageContainer,
    Box,
  }
}
</script>

<style lang="scss" scoped>
h1,
h2,
h3,
strong,
.focus {
  color: #1C2D5A;
}

h1 {
  font-size: 1.75rem;
}

h2 {
  font-size: 1.5rem;
}

h3 {
  font-size: 1.25rem;
}

.focus {
  font-size: 1.5rem;
}
</style>
